<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-2 shape-red shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2 class="display-2 text-white">Our FlexTrim Projects
                                    <span>Union Pacific Settegast Trim System</span>
                                </h2>
                                <!-- <p class="lead  text-white">This yard is in Houston. 3Z designs two trim systems for both east and west yard. This project handles over 20 switches for throwing and locking operation.</p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

        <section class="section section-lg bg-secondary section-skew">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-12">
                        <h1>
                            <i class="fa fa-road display-1"></i>
                        </h1>
                        <h2 class="display-2">Union Pacific Settegast Trim System </h2>
                        <p class="lead  text-muted">This yard is in Houston. 3Z designs two trim systems for both east and west yard. This project handles over 20 switches for throwing and locking operation.</p>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
  name: "projectFlextrim2",
  components: {}
};
</script>

<style lang="scss" scoped>
ul.list {
    padding-left: 1.2rem!important;
}
.section-skew {
    overflow: hidden;
    // padding-top: 20px;
    margin-top: 0px;
    position: relative;
    background: transparent;
    pointer-events: none;
    overflow: visible;
    &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: -120px;
        height: 200px;
        background: #f4f5f7;
        -webkit-transform: skew(0, -8deg);
        transform: skew(0, -8deg);
    }
}
</style>
